export function convertFullUrlToContentUrl(fullUrl) {
  const re = new RegExp("//[^/]+/books/([^/]+)/epub/(.+)");
  const result = re.exec(fullUrl);
  if (result) {
    return `vstcontent://${result[1]}/${result[2]}`;
  }
  return fullUrl;
}

export function convertContentUrlToFullUrl(storedUrl) {
  const re = new RegExp("vstcontent://([^/]+)/(.+)");
  const result = re.exec(storedUrl);
  if (result) {
    return `//${Jigsaw.host}/books/${result[1]}/epub/${result[2]}`;
  }
  return storedUrl;
}
